import { render, staticRenderFns } from "./DetailImage.vue?vue&type=template&id=be6f3260&"
import script from "./DetailImage.vue?vue&type=script&lang=js&"
export * from "./DetailImage.vue?vue&type=script&lang=js&"
import style0 from "./DetailImage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports